import {
    ADICIONAR_FILTRO_ENCOMENDA, LIMPAR_FILTRO_ENCOMENDA, REMOVER_FILTRO_ENCOMENDA, LISTAR_FILTROS_ENCOMENDA
  } from '../../actions/types'
  import { filtroExiste } from '../../util/filtros'
  
  const initialState = undefined

  const initial = {
  }
  
  export const filtrosAdicionadosEncomenda = (state = [], action = initialState) => {
    switch (action.type) {
      case ADICIONAR_FILTRO_ENCOMENDA: {
        if (!filtroExiste(state, action.payload)) {
          return state.concat(action.payload)
        }
        return state
      }
  
      case REMOVER_FILTRO_ENCOMENDA: {
        const copia = [...state]
        return copia.filter(filtro => filtro.chave !== action.payload.chave || filtro.valor !== action.payload.valor)
      }
  
      case LIMPAR_FILTRO_ENCOMENDA: {
        return []
      }
  
      default:
        return state
    }
  }

  export const filtrosEncomenda = (state = initial, action) => {
    switch (action.type) {
      case LISTAR_FILTROS_ENCOMENDA: {
        return action.payload.data
      }
      default:
        return state
    }
  }

  